export default function RadioField({
  field,
  value = "",
  onChange,
  error,
  disabled,
}) {
  return (
    <div className="dynamic-field-control">
      <label className="dynamic-field-control__label">
        {field.label}
        {field.required && (
          <span className="dynamic-field-control__required">*</span>
        )}
      </label>

      <div className="dynamic-field-control__options">
        {(field.options || []).map((option) => {
          const optionValue = option.value || option;

          return (
            <label key={optionValue} className="dynamic-field-control__option">
              <input
                type="radio"
                name={field.key}
                value={optionValue}
                checked={value === optionValue}
                disabled={disabled}
                onChange={(e) => onChange(field.key, e.target.value)}
              />
              <span>{option.label || option}</span>
            </label>
          );
        })}
      </div>

      {error && <span className="dynamic-field-control__error">{error}</span>}
    </div>
  );
}
